import { render, staticRenderFns } from "./BusinessRxItemSlideover.vue?vue&type=template&id=2c6834ef"
import script from "./BusinessRxItemSlideover.vue?vue&type=script&lang=js"
export * from "./BusinessRxItemSlideover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports